import React from "react";
import { useFormik } from "formik";
import classNames from "classnames";
import { InputTextarea } from "primereact/inputtextarea";

function AcceptRejectComment({ handlCommentHandler }) {
    const formik = useFormik({
        initialValues: {
            checkerComments: "",
        },
        validate: (data) => {
            let errors = {};
            if (!data.checkerComments) {
                errors.checkerComments = "This field is required.";
            }

            return errors;
        },
        onSubmit: async (data) => {},
    });

    const handleCommentChange = (e) => {
        handlCommentHandler(e.target.value);
    };

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <>
            <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                <div className="p-field p-col-12 p-md-12">
                    <div className="p-field">
                        <label htmlFor="checkerComments" className={classNames({ "p-error": isFormFieldValid("checkerComments") }, "Label__Text")}>
                            Comments<span className="Label__Required">*</span>
                        </label>
                        <InputTextarea
                            placeholder="Add Description"
                            id="checkerComments"
                            name="checkerComments"
                            value={formik?.values?.checkerComments?.replace(/\s\s+/g, " ")}
                            rows={5}
                            cols={10}
                            onChange={(e) => {
                                formik.handleChange(e);
                                handleCommentChange(e);
                            }}
                            className={classNames({ "p-invalid": isFormFieldValid("checkerComments") }, "TextArea__Round")}
                        />
                        {getFormErrorMessage("checkerComments")}
                    </div>
                </div>
            </form>
            <br />
        </>
    );
}

export default AcceptRejectComment;
